(() => {
'use strict';
document.addEventListener('click', (event) => {
 const toggle = event.target.closest('[data-atmosphere]');
 if (toggle) {
  const section = toggle.closest('[data-ritual]');
  const night = toggle.getAttribute('aria-pressed') !== 'true';
  toggle.setAttribute('aria-pressed', String(night));
  section.classList.toggle('is-night', night);
  section.querySelector('[data-day-copy]').hidden = night;
  section.querySelector('[data-night-copy]').hidden = !night;
  const label = section.querySelector('[data-atmosphere-label]');
  if (label) label.textContent = night ? 'Night' : 'Day';
 }
});
document.addEventListener('keydown', (event) => {
 if (event.key !== 'Escape') return;
 const details = event.target.closest('details[open]');
 if (details) { details.open = false; details.querySelector('summary').focus(); }
});
// Read successful controls without rebuilding the payload: apps own their selling_plan
// and properties fields. No vendor code, subscription UI or pricing is duplicated here.
const planIds = value => (value || '').trim().split(/\s+/).filter(Boolean);
document.addEventListener('change', (event) => {
 const section = event.target.closest('[data-product-section]');
 if (section) {
  const error = section.querySelector('[data-purchase-error]');
  if (error) error.hidden = true;
 }
 if (!event.target.matches('[data-variant-select]')) return;
 const form = document.getElementById(event.target.dataset.productFormId);
 const plans = form ? new FormData(form).getAll('selling_plan').map(String) : [];
 const permitted = planIds(event.target.selectedOptions[0]?.dataset.sellingPlans);
 const url = new URL(window.location.href);
 url.searchParams.set('variant', event.target.value);
 url.searchParams.delete('selling_plan');
 if (plans.length === 1 && permitted.includes(plans[0])) url.searchParams.set('selling_plan', plans[0]);
 // A reload gives Shopify and app extensions the new variant and its valid allocations.
 window.location.assign(url.href);
});

document.addEventListener('submit', (event) => {
 const form = event.target;
 if (!form.matches('[data-product-form]')) return;
 const section = form.closest('[data-product-section]');
 if (!section) return;
 const payload = new FormData(form);
 // Leave app-owned bundle forms and multi-item submissions to the app.
 if (String(payload.get('id')) !== section.dataset.variantId) return;
 if ([...payload.keys()].some(key => key.startsWith('items['))) return;
 const plans = payload.getAll('selling_plan').map(String);
 const required = section.dataset.requiresSellingPlan === 'true';
 const valid = plans.length <= 1 && (plans[0]
  ? planIds(section.dataset.sellingPlans).includes(plans[0]) : !required);
 if (valid) return; // Native POST keeps quantity, properties and selling_plan intact.
 event.preventDefault();
 event.stopImmediatePropagation();
 const error = section.querySelector('[data-purchase-error]');
 if (error) {
  error.textContent = 'Please choose a purchase option again before adding to your bag. If the options do not load, refresh the page and try again.';
  error.hidden = false;
  error.focus();
 }
}, true);

document.addEventListener('pointermove', (event) => {
 const panel = event.target.closest('[data-tilt]');
 if (!panel || !panel.closest('.motion-enabled') || event.pointerType !== 'mouse' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
 const rect = panel.getBoundingClientRect();
 panel.style.setProperty('--rotate-x', `${-((event.clientY - rect.top) / rect.height - .5) * 4}deg`);
 panel.style.setProperty('--rotate-y', `${((event.clientX - rect.left) / rect.width - .5) * 6}deg`);
});
document.addEventListener('pointerout', (event) => {
 const panel = event.target.closest('[data-tilt]');
 if (panel && !panel.contains(event.relatedTarget)) { panel.style.setProperty('--rotate-x', '0deg'); panel.style.setProperty('--rotate-y', '0deg'); }
});
})();
